import { CardSpg } from "@duosoftbg/nacid-components";
import { Box, CardContent, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Groups from "./Groups";
import Roles from "./Roles";

function a11yProps(tab) {
  return {
    id: `group-role-tab-${tab}`,
    "aria-controls": `group-role-tabpanel-${tab}`,
  };
}

const tabs = [
  {
    key: 0,
    title: "t.tab.groups",
    component: <Groups />,
  },
  {
    key: 1,
    title: "t.tab.roles",
    component: <Roles />,
  },
];

const GroupsAndRolesTabs = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <CardSpg my={4} style={{ overflow: "visible" }}>
      <CardContent style={{ position: "relative" }}>
        <Tabs value={activeTab} onChange={handleChange}>
          {tabs.map((tab) => (
            <Tab key={tab.key} label={t(tab.title)} {...a11yProps(tab.key)} />
          ))}
        </Tabs>
        <Box>
          {tabs.map((tab) => (
            <div
              key={tab.key}
              role="tabpanel"
              hidden={activeTab !== tab.key}
              id={`group-role-tabpanel-${tab.key}`}
              aria-labelledby={`group-role-tab-${tab.key}`}
            >
              {activeTab === tab.key && tab.component}
            </div>
          ))}
        </Box>
      </CardContent>
    </CardSpg>
  );
};

export default GroupsAndRolesTabs;
